import { claimKindLabel } from "@/lib/trust";
import type { ResolutionSummary } from "@/lib/resolutionSummary";

interface IncidentResolutionPanelProps {
  summary: ResolutionSummary;
}

export function IncidentResolutionPanel({ summary }: IncidentResolutionPanelProps) {
  return (
    <section className="iw-section iw-resolution" aria-label="Resolution summary">
      <h3 className="iw-section__title iw-section__title--prominent">{summary.headline}</h3>
      <p className="iw-resolution__claim-kind">{claimKindLabel(summary.claimKind)}</p>

      <div className="iw-resolution__block">
        <h4 className="iw-resolution__subtitle">Suggested resolution</h4>
        <p className="iw-resolution__suggested">{summary.suggestedResolution}</p>
      </div>

      <div className="iw-resolution__block">
        <h4 className="iw-resolution__subtitle">Evidence</h4>
        {summary.evidence.length > 0 ? (
          <ul className="iw-resolution__list">
            {summary.evidence.map((item) => (
              <li key={`${item.label}:${item.value}`}>
                <strong>{item.label}:</strong> {item.value}
              </li>
            ))}
          </ul>
        ) : (
          <p className="iw-resolution__empty">Not available</p>
        )}
      </div>

      {summary.verificationRequired ? (
        <div className="iw-resolution__block iw-resolution__block--required">
          <h4 className="iw-resolution__subtitle">Verification required</h4>
          <p className="iw-resolution__failed">
            Runtime Doctor has not confirmed a healthy verdict. Do not treat this as resolved.
          </p>
        </div>
      ) : (
        <p className="iw-resolution__verified">Verified outcome — Runtime Doctor verdict is healthy.</p>
      )}

      <dl className="iw-resolution__meta">
        <div>
          <dt>Elapsed (action)</dt>
          <dd>{summary.elapsedSeconds} seconds</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd>{summary.verified ? "Verified" : "Awaiting verification"}</dd>
        </div>
      </dl>
    </section>
  );
}
